module.exports = __webpack_public_path__ + "static/media/PiaicLogo.fb7de414.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PiaicLogo.svg
// module id = 388
// module chunks = 0